export const LISTS_CAMPUSES = 'LISTS_CAMPUSES'
export const LISTS_UTILITIES = 'LISTS_UTILITIES'
export const LISTS_TRANSITS = 'LISTS_TRANSITS'
export const LISTS_RESET = 'LISTS_RESET'

export default {
    LISTS_CAMPUSES,
    LISTS_UTILITIES,
    LISTS_TRANSITS,
    LISTS_RESET
}
